import { AuthReducer } from './auth/Auth'
import { DashboardReducer } from './dashboard/Dashboard'
import { NotificationsReducer } from './notifications/Notifications'

export const rootReducer = {
  Auth:           AuthReducer,
  Dashboard:      DashboardReducer,
  Notifications:  NotificationsReducer,
}
